import { toHtml, isEmptyValue } from '../editor/content.js';

function seeded(seedStr) {
  let h = 2166136261;
  for (let i = 0; i < seedStr.length; i++) h = Math.imul(h ^ seedStr.charCodeAt(i), 16777619);
  return () => {
    h += 0x6d2b79f5;
    let t = h;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function shuffle(list, seedStr) {
  const rnd = seeded(seedStr);
  const a = [...list];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rnd() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function validChoices(choices) {
  return (Array.isArray(choices) ? choices : []).filter((c) => String(c?.text ?? '').trim());
}

export const mcq = {
  id: 'mcq',
  name: 'Multiple choice',
  short: 'Choices',
  description: 'Pick the right option. They’re shuffled every time.',
  icon: 'list',
  fields: [
    {
      key: 'question',
      label: 'Question',
      hint: 'What you’ll be asked.',
      kind: 'rich',
      required: true,
      placeholder: 'Which nerve abducts the eye?',
    },
    {
      key: 'choices',
      label: 'Options',
      hint: 'Tap the circle next to every correct option.',
      kind: 'choices',
      required: true,
    },
    { key: 'explanation', label: 'Explanation', hint: 'Shown with the answer.', kind: 'rich' },
  ],
  ords: () => [0],
  cardLabel: () => 'Card',
  checks: {
    choices: (v) => {
      const choices = validChoices(v);
      if (choices.length < 2) return 'Fill in at least two options.';
      if (!choices.some((c) => c.correct)) return 'Tap the circle next to the right answer.';
      return null;
    },
  },
  validate: (f) => {
    if (isEmptyValue(f.question)) return 'Question is empty.';
    const choices = validChoices(f.choices);
    if (choices.length < 2) return 'Add at least two choices.';
    if (!choices.some((c) => c.correct)) return 'Mark at least one choice as correct.';
    return null;
  },
  render: (note, _ord, ctx = {}) => {
    const choices = validChoices(note.fields.choices);
    const seed = `${ctx.cardId ?? note.id}:${ctx.reps ?? 0}`;
    return {
      front: toHtml(note.fields.question),
      back: isEmptyValue(note.fields.explanation) ? '' : toHtml(note.fields.explanation),
      mode: 'mcq',
      choices: shuffle(choices, seed),
      multi: choices.filter((c) => c.correct).length > 1,
    };
  },
};
